import {
  caseReferenceNumberIsUnique,
  dateFieldDefault,
  intFieldDefault,
  textFieldDefault,
} from "../../validationRules";
import { trueFalseDefaultOptions, yesNoDefaultOptions } from "./formDefinitionFunctions";
import { formValue } from "../../formServiceFunctions";
import { FormDefinition } from "../../../types/ProductService/ProductService";
import { UseForm } from "../../../types/UseForm";
import { ShortTimeWork } from "../../../types/Products/ShortTimeWork/ShortTimeWork";
import { isKnownPartner } from "../../partnerReferenceService";

export const fullFormDefinition: FormDefinition<ShortTimeWork> = ({ product }) => ({
  product: {
    sections: [
      {
        label: "Angaben Antragsteller",
        elements: [
          {
            type: "ValidatorSelect",
            path: "shortTimeWork.petitioner.gender",
            options: () => [{ value: "male" }, { value: "female" }, { value: "diverse" }],
          },
          {
            type: "ValidatorTextField",
            path: "shortTimeWork.petitioner.givenName",
            validators: [...textFieldDefault],
          },
          {
            type: "ValidatorTextField",
            path: "shortTimeWork.petitioner.familyName",
            validators: [...textFieldDefault],
          },
          {
            type: "ValidatorDateField",
            path: "shortTimeWork.petitioner.birthDate",
            validators: [...dateFieldDefault],
          },
          {
            type: "ValidatorSelect",
            path: "shortTimeWork.hasChildren",
            options: () => yesNoDefaultOptions("shortTimeWork.hasChildren"),
          },
          {
            type: "ValidatorSelect",
            path: "shortTimeWork.taxClass",
            options: () => [{ value: 1 }, { value: 2 }, { value: 3 }, { value: 4 }, { value: 5 }, { value: 6 }],
          },
          {
            type: "ValidatorTextField",
            path: "shortTimeWork.personalTextMessage",
            validators: textFieldDefault,
            additionalProps: {
              multiline: true,
              rows: 12,
              fullWidth: true,
            },
          },
        ],
      },
      {
        label: "Weitere Angaben",
        elements: [
          {
            type: "ValidatorSelect",
            path: "shortTimeWork.reason",
            options: () => [{ value: "corona" }, { value: "unsure" }, { value: "other" }],
          },
          {
            type: "ValidatorSelect",
            path: "shortTimeWork.contractTerminated",
            options: () => yesNoDefaultOptions("shortTimeWork.contractTerminated"),
          },
          {
            type: "ValidatorDateField",
            path: "shortTimeWork.contractTerminationReceivedDate",
            validators: [...dateFieldDefault],
            isHidden: ({ values }: { values: UseForm["values"] }) =>
              formValue(values, "shortTimeWork.contractTerminated") !== "yes",
          },
          {
            type: "ValidatorSelect",
            path: "shortTimeWork.shortTimeWorkStatus",
            options: () => [{ value: "announced" }, { value: "applied_for" }, { value: "implemented" }],
          },
          {
            type: "ValidatorTextField",
            path: "shortTimeWork.percentageWorkTime",
            validators: [...intFieldDefault],
          },
          {
            type: "ValidatorSelect",
            path: "shortTimeWork.affectedEmployees",
            options: () => [{ value: "just_me" }, { value: "some" }, { value: "all" }],
          },
          {
            type: "ValidatorSelect",
            path: "shortTimeWork.hasCollectiveAgreement",
            options: () => [{ value: "yes" }, { value: "no" }, { value: "unsure" }],
          },
          {
            type: "ValidatorSelect",
            path: "shortTimeWork.hasWorkCouncil",
            options: () => yesNoDefaultOptions("shortTimeWork.hasWorkCouncil"),
          },
          {
            type: "ValidatorSelect",
            path: "shortTimeWork.workCouncilAgreement",
            isHidden: ({ values }: { values: UseForm["values"] }) =>
              formValue(values, "shortTimeWork.hasWorkCouncil") !== "yes",
            options: () => [{ value: "yes" }, { value: "no" }, { value: "unsure" }],
          },
          {
            type: "ValidatorSelect",
            path: "shortTimeWork.shortTimeClauseInContract",
            options: () => [{ value: "yes" }, { value: "no" }, { value: "unsure" }],
          },
          {
            type: "ValidatorSelect",
            path: "shortTimeWork.employeeHasAgreed",
            options: () => yesNoDefaultOptions("shortTimeWork.employeeHasAgreed"),
          },
          {
            type: "ValidatorNumberField",
            path: "shortTimeWork.grossSalary",
            fieldType: "money",
          },
          {
            type: "ValidatorTextField",
            path: "shortTimeWork.weeklyWorkingHours",
            validators: [...intFieldDefault],
          },
          {
            type: "ValidatorSelect",
            path: "shortTimeWork.agencyWorker",
            options: () => yesNoDefaultOptions("shortTimeWork.agencyWorker"),
          },
          {
            type: "ValidatorTextField",
            path: "shortTimeWork.employerName",
            validators: [...textFieldDefault],
          },
          {
            type: "ValidatorSelect",
            path: "shortTimeWork.companySize",
            options: () => [{ value: "<10" }, { value: "10+" }],
          },
          {
            type: "ValidatorSelect",
            path: "shortTimeWork.legalExpenseInsurance",
            options: () => trueFalseDefaultOptions("shortTimeWork.legalExpenseInsurance"),
          },
          {
            type: "ValidatorTextField",
            path: "shortTimeWork.caseInsurance.caseReferenceNumber",
            validators: [
              ...textFieldDefault,
              {
                validator: caseReferenceNumberIsUnique,
                params: [product.caseInsurance.caseReferenceNumber, product.id],
                message: "Diese Schadennummer existiert bereits in einem anderen Rechtsfall.",
              },
            ],
            isHidden: ({ values }: { values: UseForm["values"] }) =>
              formValue(values, "shortTimeWork.legalExpenseInsurance") !== true ||
              !isKnownPartner(formValue(values, "shortTimeWork.acquisitionPartner"), "advocard"),
          },
        ],
      },
    ],
  },
});
